
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotlights",
      function () {
        return require("private-next-pages/spotlights/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spotlights"])
      });
    }
  